module.exports = __webpack_public_path__ + "typescript.svg";